import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { getUserDetails } from "../utils/userDetailsUtils";

const updateLLM = async ({ data, id }) => {
  const user = getUserDetails();

  const payload = {
    action: "updateLLM",
    companyid: user.companyid,
    id,
    ...data,
  };
  const queryString = new URLSearchParams(payload).toString();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryString}`,
  );

  return response;
};

const useUpdateLLM = () => {
  return useMutation({
    mutationFn: updateLLM,
  });
};

export default useUpdateLLM;